import {
  Card,
  CardContent,
  CardDescription,
  CardHeader,
  CardTitle,
} from "@/shared/components/ui/card";
import t from "@/lang/lang";

export function ContractCard() {
  return (
    <Card>
      <CardHeader>
        <CardTitle>{t("Verträge")}</CardTitle>
        <CardDescription>
          {t(
            "Informationen zu Verträgen, sofern die Beziehung durch solche formalisiert wurde.",
          )}
        </CardDescription>
      </CardHeader>
      <CardContent>Kein Vertrag</CardContent>
    </Card>
  );
}
